import {Link} from '@primer/react'

import {useIsMergeBoxSidePanel} from '../../../../../contexts/MergeBoxLayoutContext'
import {useMergeControlInputs} from '../merge-control-context'

export function MergeQueueInstructions() {
  const {
    baseRefName,
    pullRequest: {mergeQueue},
  } = useMergeControlInputs()
  const isSidePanel = useIsMergeBoxSidePanel()

  return (
    <span className={`f6 fgColor-muted${isSidePanel ? '' : ' pl-2'}`}>
      This repository uses the{' '}
      <Link href={mergeQueue?.url} inline>
        merge queue
      </Link>{' '}
      for all merges into the {baseRefName} branch.
    </span>
  )
}
